import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./whychoose.css";
import wcImg from "../../img/wcu/why-choose-surbhimam-image.png";
// import w1 from "../../img/Why-Choose-Us-icons/Comprehensive-Astrological-Services.png";
import w2 from "../../img/Why-Choose-Us-icons/High-Quality-Astrological-Forecasts-Advice.png";
import w3 from "../../img/Why-Choose-Us-icons/Trustworthy-and-Confidential.png";
import w4 from "../../img/Why-Choose-Us-icons/Expertise-and-Experience.png";
import w5 from "../../img/Why-Choose-Us-icons/Practical-Solutions.png";
import w6 from "../../img/Why-Choose-Us-icons/Holistic-Approach.png";
import image from "../../img/Why-Choose-Us-icons/IAF-logo.jpg";
import experience from "../../img/Why-Choose-Us-icons/20+experience.png";

function WhyChoose() {
  return (
    <>
      <section className="card-section spacing pb-lg-4 pt-lg-2 mt-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card-section-content main-heading card-heading col-12  t-head mb-lg-4">
                <h1 className="d-flex justify-content-center">
                  Best Astrologer in Gurgaon -Dr. Surabhi Bhatnagar
                </h1>
                {/* <p>
                  At Blessings Astrology, we offer reliable and personalized
                  astrological guidance through years of experience complemented
                  by deep spiritual understanding. Our consultations are led by
                  Dr. Surabhi Bhatnagar, a highly respected astrology consultant
                  in Gurgaon/ Gurugram known for her knowledge and compassionate
                  approach. Recognized as the Top Astrologer in Delhi NCR, Dr.
                  Surabhi combines Vedic astrology with modern insights to
                  provide solutions that truly transform lives. As one of the
                  Top Astrologers in Gurgaon/Gurugram, she provides in-depth and
                  personalized insights that encompass all aspects of life,
                  including career, business, relationships, well-being, and
                  finances. Apart from horoscope consultations, our services
                  include numerology, vastu consultations, corporate
                  astrological solutions, tarot card reading, and more. Every
                  session is designed to bring clarity, practical remedies, and
                  spiritual alignment to help you make confident and informed
                  choices.
                </p>
                <p>
                  Services we offer:{" "}
                  <a href="https://www.blessingsastrology.com/service/astrology">
                    Astrology
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/vastu-shastra">
                    {" "}
                    vastu shastra
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/tarot">
                    {" "}
                    tarot card reading
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/palmistry">
                    {" "}
                    palmistry
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/numerology">
                    {" "}
                    numerology
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/reiki-healing">
                    {" "}
                    Reiki healing
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/puja">
                    {" "}
                    puja
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/handwriting-and-signature-analysis">
                    {" "}
                    handwriting and signature analysis
                  </a>{" "}
                  |{" "}
                  <a href="https://www.blessingsastrology.com/service/corporate-training">
                    {" "}
                    corporate training.
                  </a>
                </p> */}
                <p>
                  Dr. Surabhi Bhatnagar, Founder of Blessings Astrology, is the
                  leading and<b> best trusted astrologer in Gurgaon,</b> India.
                  She has positively transformed the lives of over 10,000+
                  individuals across India and internationally, including the
                  USA, Australia, Germany, the UK, Canada, Singapore, and many
                  more countries. With 20+ years of experience, she has guided
                  thousands of individuals and families across India and
                  globally, helping them move forward with clarity, confidence,
                  and positivity. She has received several prestigious awards
                  and accolades in the field of occult sciences. Her expertise
                  blends traditional knowledge with thoughtful and practical
                  insights, making her one of the best astrologers in Delhi NCR,
                  India. Her expertise spans multiple domains, including{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/vastu-shastra">
                    Vastu Shastra Consultation
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://www.blessingsastrology.com/service/astrology">
                    Astrology Services
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/numerology">
                    Numerology
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/tarot">
                    Tarot Card Reading
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/palmistry">
                    Palm Reading
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/reiki-healing">
                    Reiki Healing
                  </a>
                  ,{" "}
                  <a
                    className="fw-bold"
                    href="https://blessingsastrology.com/service/handwriting-and-signature-analysis">
                    Handwriting & Signature Analysis
                  </a>
                  , and other healing practices. She is also a lifetime member
                  of the International Astrology Foundation (USA) and is
                  associated with the International Center for Reiki Training
                  (ICRT), USA. Dr. Surabhi Bhatnagar, the Best Numerologist in
                  Delhi , continues to guide and inspire people worldwide with
                  her personalized approach.
                </p>
              </div>
            </div>
            {/* <div className="col-lg-4 t-card-img">
              <img src={wcImg} className="img-fluid w-100 " alt="Achivements of Dr. Surabhi Bhatnagar"></img>



            </div> */}
            <div className="col-12 main-card-section d-lg-block d-none">
              <div className="row h-100">
                <div className="col-md-2 p-0">
                  <div className="three-section-card three-section-card-1">
                    <div className="ts-icon">
                      <img
                        src={image}
                        className="img-fluid w-50"
                        alt="LifeTime Member of IAF | Blessings Astrology"
                      />
                      {/* <h3>
                        Comprehensive Astrological Services
                      </h3> */}
                      <h3>LifeTime Member of IAF</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className="three-section-card three-section-card-2">
                    <div className="ts-icon">
                      <img
                        src={w2}
                        className="img-fluid w-50"
                        alt=" Trusted Expert"
                      />
                      <h3>Trusted Expert</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className="three-section-card three-section-card-3">
                    <div className="ts-icon">
                      <img
                        src={w5}
                        className="img-fluid w-50"
                        alt="Accurate and Reliable Predictions"
                      />

                      <h3>Accurate and Reliable Predictions</h3>
                    </div>
                    {/* <div className="ts-content">

                      <p>
                        Joining hands with NAB Delhi can make a difference in the lives of visually impaired individuals. As a CSR partner, your organization can help provide vital resources and services to those in need. By supporting us, your organization can contribute to the empowerment and inclusion of the visually impaired community. Join us today to create a positive impact and fulfill your CSR objectives.
                      </p>
                      <a href="/be-a-csr" alt="NAB Delhi Be a CSR" aria-label="NAB Delhi Be a CSR Page" className="default-btn">Be a CSR Partner</a>
                    </div> */}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className="ts-icon three-section-card">
                    <img
                      src={w4}
                      className="img-fluid w-50"
                      alt="Personal Empowerment"
                    />
                    <h3>Personal Empowerment</h3>
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className="ts-icon three-section-card three-section-card-4 three-section-card-5">
                    <img
                      src={experience}
                      className="img-fluid w-50"
                      alt="More Than 20+ Year of Experience"
                    />
                    <h3>
                      More Than <br></br> 20+ Year of Experience{" "}
                    </h3>
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className="ts-icon three-section-card three-section-card-6">
                    <img
                      src={w6}
                      className="img-fluid w-50"
                      alt="Holistic Approach"
                    />
                    <h3>Holistic Approach</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default WhyChoose;
